import React from 'react';
import { motion } from 'framer-motion';

const railClass = (rail) =>
  // The 3D skull lives in the RIGHT portion of the canvas. To avoid overlap, ALL
  // text rails sit on the LEFT side of the grid (cols 1-6), unless explicitly
  // 'center' (for the contact CTA).
  rail === 'center'
    ? 'md:col-start-3 md:col-end-11'
    : 'md:col-start-1 md:col-end-7 md:pr-6';

export default function SegmentSection({ data, index, segmentRef, children }) {
  return (
    <section
      id={data.id}
      ref={segmentRef}
      data-testid={data.testId}
      className="relative w-full py-16 sm:py-20"
    >
      <div className="mx-auto max-w-[1240px] px-5 sm:px-8 grid grid-cols-1 md:grid-cols-12 gap-8">
        <div className={`${railClass(data.rail)} relative z-20`}>
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: 'easeOut' }}
            viewport={{ once: true, amount: 0.25 }}
            className=""
          >
            <div className="flex items-center gap-3 mb-4">
              <span className="font-ui text-[10px] tracking-[0.4em] uppercase text-[color:var(--gold)]">
                CH {data.number}
              </span>
              <span className="h-px w-10 bg-[color:var(--gold)]/60" />
              <span className="font-ui text-[10px] tracking-[0.32em] uppercase text-[color:var(--text-dim)]">
                {data.location}
              </span>
            </div>

            <h2 className="font-deco text-3xl sm:text-4xl md:text-5xl leading-[1.05] tracking-tight title-deco">
              <span className="title-poster">{data.title}</span>
            </h2>

            <div className="mt-6 max-w-[58ch] text-[color:var(--text-sand)] text-base sm:text-[17px] leading-relaxed">
              {children}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
